//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Drawer from '@/components/drawer';
export default {
  name: 'EditAgentAppDetail',
  components: { Drawer },
  props: {
    row: { type: Object, default: () => {} },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showJson: false,
      currentJson: '',
      jsonData: '{}',
      form: {
        name: '',
        description: '',
        type: '',
        id: '',
        scheduler_type: '',
      },
      rules: {
        name: [{ required: true, message: '请输入应用名称', trigger: 'submit' }],
        type: [{ required: true, message: '请选择应用类型', trigger: 'submit' }],

        scheduler_type: [{ required: true, message: '请选择调度类型', trigger: 'submit' }],
      },
    };
  },
  computed: {
    // 只有 workflow 才显示调度类型
    schedulerTypeHidden() {
      return this.form.type !== 'workflow';
    },
  },
  watch: {
    visible() {
      if (this.visible) {
        this.form = {
          name: '',
          description: '',
          type: '',
          id: '',
          scheduler_type: '',
        };
      }
    },
    'form.type'(val) {
      if (val === 'ma') {
        this.form.scheduler_type = 'temporal';
      } else if (val === 'chatflow') {
        this.form.scheduler_type = 'local';
      }
      // workflow 不自动赋值，保留用户选择
    },
  },
  mounted() {},
  methods: {
    close() {
      this.$emit('close');
    },

    createAgentApp() {
      this.$refs.form.validate((valid) => {
        // valid
        console.log('%c Line:77 🥤 valid', 'color:#ffdd4d', valid);
        if (valid) {
          // createAgentApp
          this.$request({
            url: this.$api.createAgentApp,
            data: {
              agent_app: {
                ...this.form,
              },
            },
          }).then((res) => {
            console.log('%c Line:130 🍫 res', 'color:#33a5ff', res);
            // res
            console.log('%c Line:154 🥕 res', 'color:#42b983', res);
            this.$emit('refresh');
            this.close();
          });
        } else {
          this.$message.warning('请填写必填项');
        }
      });
    },
  },
};
